import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../../Icon';
import { MemoryProgressBar } from '../MemoryProgressBar';
import styles from './MemoryChapterCard.css';

const cx = classnames.bind(styles);

function MemoryChapterCard({ label, count, max, isReady, isPending, onSelect }) {
    return (
        <button
            type='button'
            className={cx('root', { ready: isReady })}
            onClick={onSelect}
        >
            <span className={styles.title}>{label}</span>
            {isReady ? (
                <span className={styles.footer}>
                    <span className={styles.chapterReady}>
                        <Icon name='checked' className={styles.checkIcon} />
                        {isPending ? 'Saving your chapter…' : 'Chapter ready'}
                    </span>
                    {!isPending && (
                        <span className={styles.viewChapter}>
                            View chapter
                            <Icon name='chevronRight' className={styles.arrowIcon} />
                        </span>
                    )}
                </span>
            ) : (
                <span className={styles.footer}>
                    <MemoryProgressBar value={count} max={max} />
                    <span className={styles.count}>{count} / {max}</span>
                </span>
            )}
        </button>
    );
}

MemoryChapterCard.propTypes = {
    label: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    isReady: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired
};

export {
    MemoryChapterCard
};
